import React from 'react';
import { useQuery, gql } from '@apollo/client';

// GraphQL query for current user
const GET_CURRENT_USER = gql`
  query GetCurrentUser {
    currentUser {
      id
      firstName
      lastName
      patronymic
      email
      phone
      dateOfBirth
      profilePhoto
      address {
        locality
        street
        house
        building
        apartment
      }
      studentProfile { educationLevel }
      chairmanProfile { tosName }
      villageHeadProfile { localityName }
    }
  }
`;

export default function Profile() {
  const { loading, error, data } = useQuery(GET_CURRENT_USER);

  if (loading) return <p>Загрузка профиля...</p>;
  if (error) return <p>Ошибка: {error.message}</p>;

  const user = data.currentUser;

  return (
    <div className="max-w-4xl mx-auto p-4">
      {/* Header with cover and avatar */}
      <div className="relative h-48 bg-gray-200 rounded-lg overflow-hidden">
        <img
          src={user.coverPhoto || '/default-cover.jpg'}
          alt="Cover"
          className="object-cover w-full h-full"
        />
        <div className="absolute -bottom-12 left-6">
          <img
            src={user.profilePhoto || '/default-avatar.png'}
            alt="Avatar"
            className="w-24 h-24 rounded-full border-4 border-white object-cover"
          />
        </div>
      </div>

      {/* Name and basic info */}
      <div className="mt-16 ml-6">
        <h1 className="text-2xl font-semibold">
          {user.firstName} {user.lastName}
        </h1>
        {user.patronymic && <p className="text-sm text-gray-600">{user.patronymic}</p>}
      </div>

      {/* Info sections */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
        <div className="p-4 bg-white rounded-lg shadow">
          <h2 className="text-lg font-medium mb-2">Контакты</h2>
          <p><strong>Email:</strong> {user.email}</p>
          <p><strong>Телефон:</strong> {user.phone}</p>
          <p><strong>Дата рождения:</strong> {user.dateOfBirth}</p>
        </div>

        <div className="p-4 bg-white rounded-lg shadow">
          <h2 className="text-lg font-medium mb-2">Адрес</h2>
          {user.address ? (
            <p>
              {user.address.street}, {user.address.locality}<br />
              Дом: {user.address.house}
              {user.address.building && `, корп. ${user.address.building}`}
              {user.address.apartment && `, кв. ${user.address.apartment}`}
            </p>
          ) : <p>Адрес не указан</p>}
        </div>
      </div>

      {/* Role-specific info */}
      <div className="mt-6 space-y-4">
        {user.studentProfile && (
          <div className="p-4 bg-white rounded-lg shadow">
            <h2 className="text-lg font-medium mb-2">Студенческий профиль</h2>
            <p><strong>Уровень образования:</strong> {user.studentProfile.educationLevel}</p>
          </div>
        )}
        {user.chairmanProfile && (
          <div className="p-4 bg-white rounded-lg shadow">
            <h2 className="text-lg font-medium mb-2">Профиль председателя</h2>
            <p><strong>ТСО:</strong> {user.chairmanProfile.tosName}</p>
          </div>
        )}
        {user.villageHeadProfile && (
          <div className="p-4 bg-white rounded-lg shadow">
            <h2 className="text-lg font-medium mb-2">Глава поселения</h2>
            <p><strong>Населённый пункт:</strong> {user.villageHeadProfile.localityName}</p>
          </div>
        )}
      </div>

      {/* Placeholder for future tabs (Posts, Friends, About) */}
      {/* e.g. <Tabs>...</Tabs> */}
    </div>
  );
}
